
export default function SettingsForm({
  handleChange,
  value,
  defaultValue = undefined,
  labelText,
  labelFor,
  id,
  type,
  name,
  min,
  max,
  isRequired = false,
  customClass,
  options,
}) {
  const actualValue = value !== undefined ? value : defaultValue;

  return (
    <div className="w-full">
      <label htmlFor={labelFor} className="text-dark1 text-bodyMM mb-2">
        {labelText}
      </label>
      {type === "number" ? (
        <input
          onChange={handleChange}
          value={actualValue}
          id={id}
          name={name}
          type={type}
          min={min}
          max={max}
          required={isRequired}
          className={`${customClass}`}
        />
      ) : (
        <select
          onChange={handleChange}
          value={actualValue}
          id={id}
          name={name}
          required={isRequired}
          className={`${customClass}`}
        >
          {options.map((option) => (
            <option
              key={option.id} // Adăugați cheia unică pentru fiecare opțiune
              value={option.value}
              defaultValue={option.value === actualValue} // Utilizați defaultValue în loc de selected
            >
              {option.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
